import { css } from '@inter-ikea-kompis/web-component';
export default class FinancialServicesStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        return css `
			:host {
				display: flex;
				color: ${options.theme.color.neutral.grey900};
			}
		`;
    }
}
//# sourceMappingURL=FinancialServicesStyle.js.map